export default "__VITE_ASSET__DFTXdEge__"